import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSuccess } from "../redux/reducers/app/login";
import api from "../services/api";
import { APIS } from "../endpoints";
import { markLoggedOut } from "../util/sessionGuard";

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return async () => {
    markLoggedOut();
    try {
      // Revoke server-side refresh capability for this session (bumps
      // tokenVersion) so a still-valid refresh token left in another
      // tab/device can't silently re-authenticate. Must be awaited
      // before clearing storage below, while the access token is still
      // present to authenticate this call.
      await api.post(APIS.logout);
    } catch {
      // Best-effort: local logout proceeds even if revocation fails.
    }
    dispatch(logoutSuccess());
    localStorage.clear();
    navigate("/admin-login");
  };
};
